import * as React from "react";
import { extent } from "d3";
import { scaleLinear, scaleBand } from "d3-scale";
import { compose, scaleQual12, scaleQual6 } from "sszvis";
import { AxisX, AxisYOrdinal } from "../sszvis-components/Axis";
import { H4 } from "../theme/text";
import { css } from "emotion";
import { spacing } from "../theme/layout";
import { Bar } from "../sszvis-components/Bar";
const BAR_HEIGHT = 20;
const LABEL_HEIGHT = 25;
const BAR_WITH_LABEL_HEIGHT = BAR_HEIGHT + LABEL_HEIGHT;
export class MiniBarChart extends React.Component {
    constructor() {
        super(...arguments);
        this.calculateScales = () => {
            const { unit, getTimeValue, getLocation, getFacet, getMeasureValue, locations, selectedGeoEntity, selectedDimension, width, margins, metadata, data, valueScale, colorScale, title, showYAxis } = this.props;
            // All facets of the dataset, except the ones used as SmallMultiples divider
            const otherDimensionFacets = Array.from(new Set(data.map(getFacet)));
            const chartWidth = width - margins.left - margins.right;
            const chartHeight = BAR_WITH_LABEL_HEIGHT * otherDimensionFacets.length;
            const height = chartHeight + margins.top + margins.bottom + LABEL_HEIGHT;
            const [minValue, maxValue] = extent(data, getMeasureValue);
            const _valueScale = valueScale
                ? valueScale
                : scaleLinear().domain([Math.min(0, minValue), maxValue]);
            _valueScale.range([0, chartWidth]).nice();
            const _colorScale = colorScale
                ? colorScale
                : (metadata.facets.length > 6 ? scaleQual12() : scaleQual6()).domain(metadata.facets.map(f => f.label));
            const categoryScale = scaleBand()
                .domain(otherDimensionFacets)
                .rangeRound([0, chartHeight])
                .paddingInner(LABEL_HEIGHT / BAR_WITH_LABEL_HEIGHT);
            return {
                height,
                chartWidth,
                chartHeight,
                categoryScale,
                valueScale: _valueScale,
                colorScale: _colorScale
            };
        };
    }
    render() {
        const { unit, getTimeValue, getLocation, getFacet, getMeasureValue, locations, selectedGeoEntity, width, margins, metadata, data, title, showYAxis } = this.props;
        const { valueScale, colorScale, categoryScale, height, chartHeight, chartWidth } = this.calculateScales();
        // FIXME: bar Chart axis labels often overflow their column in small multiples
        const limitedHeight = 250;
        return (<div>
        {title && (<H4 className={css `
              margin-left: ${margins.left}px;
              ${spacing.mt3};
            `}>
            {title}
          </H4>)}
        <svg width={width} height={limitedHeight}>
        
          <Bar x={compose((d) => valueScale(Math.min(0, d)), getMeasureValue)} width={compose((d) => Math.abs(valueScale(d) - valueScale(0)), getMeasureValue)} y={compose(categoryScale, getFacet)} height={categoryScale.bandwidth()} fill={compose(colorScale, getFacet)} stroke={"white"} data={data} gProps={{
            transform: `translate(${margins.left}, ${margins.top +
                LABEL_HEIGHT})`
        }}/>

          <AxisX scale={valueScale} title={unit} orient="bottom" ticks={Math.min(10, Math.floor(chartWidth / 80))} alignOuterLabels gProps={{
            transform: `translate(${margins.left}, ${chartHeight +
                margins.top +
                LABEL_HEIGHT})`
        }}/>

          <AxisYOrdinal scale={categoryScale} orient="right" gProps={{
            transform: `translate(${margins.left}, ${margins.top +
                LABEL_HEIGHT -
                categoryScale.bandwidth()})`
        }}/>
        </svg>
      </div>);
    }
}
MiniBarChart.defaultProps = {
    showYAxis: true
};



// WEBPACK FOOTER //
// ./src/detail/MiniBarChart.tsx